<div class="mat-dialog">
  <mat-dialog-content>
    <div class="close-btn" mat-dialog-close>
      <img src="assets/close.svg" alt="close" />
    </div>
    <img class="image" [src]="data.path" />
  </mat-dialog-content>
</div>
